export const links = [
  {
    name: 'linkedin-logo',
    url: 'https://www.linkedin.com/in/anastasia-laczko/',
    icon: 'fa-linkedin'
  },
  {
    name: 'medium-logo',
    url: 'https://anastasia-laczko.medium.com/',
    icon: 'fa-medium'
  },
  {
    name: 'github-logo',
    url: 'https://www.linkedin.com/in/anastasia-laczko/',
    icon: 'fa-github'
  }
];
